<template>

<com-item name="game.summary" :size="size" :loading="loading" theme="blue" class="summary-wrapper" :noHover="true">

	<template v-slot:stats>

		<div class="summary" v-if="active">

			<div class="summary-head" :style="{backgroundImage: backgroundImage}"></div>

			<div class="summary-name">{{ game.name }}</div>

			<div class="summary-meta" v-if="game.year">

				<span v-if="game.year">{{ game.year }}</span>

				<span v-if="playerCount" class="summary-meta-sep">·</span>
				<span v-if="playerCount">{{ playerCount }}</span>

				<span v-if="duration" class="summary-meta-sep">·</span>
				<span v-if="duration">{{ duration }}</span>

				<span v-if="game.rank" class="summary-meta-sep">·</span>
				<span v-if="game.rank">Rank {{ game.rank }}</span>

			</div>

			<div class="summary-people" v-if="game.designers && game.designers.length">{{ game.designers.join(', ') }}</div>

			<div class="summary-publisher" v-if="game.publishers && game.publishers.length">{{ game.publishers.join(', ') }}</div>

		</div>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		game: function() {

			return this.$store.getters['page/insights/game/game']

		},

		backgroundImage: function() {

			if (!this.game || !this.game.id) return ''
			return 'url(' + this.$util.thumbnail.game.large(this.game.id) + ')'

		},

		active: function() {

			return this.game && this.game.id && !this.loading

		},

		playerCount: function() {

			if (!this.game) return ''
			if (this.game.playersMin && this.game.playersMax) {
				if (this.game.playersMin === this.game.playersMax) return this.game.playersMin + ' Players'
				return this.game.playersMin + '–' + this.game.playersMax + ' Players'
			}
			if (this.game.playersMin) return this.game.playersMin + '+ Players'
			return ''

		},

		duration: function() {

			if (!this.game) return ''
			if (this.game.timeMin && this.game.timeMax) {
				if (this.game.timeMin === this.game.timeMax) return this.game.timeMin + ' Min'
				return this.game.timeMin + '–' + this.game.timeMax + ' Min'
			}
			if (this.game.timeMax) return this.game.timeMax + ' Min'
			return ''

		},


	}

}

</script>

<style scoped>

.summary {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.is-mobile .summary-wrapper >>> .insights-item-content {
	min-height: auto;
	height: auto;
	padding-bottom: 20px;
}

.summary-head {
	height: 192px;
	width: 100%;
	border-radius: 4px 4px 0px 0px;
	background-position: 50% 50%;
	background-size: cover;
	margin-bottom: 14px;
}

.summary-name {
	font-size: 22px;
	font-weight: 700;
	color: #fff;
	text-align: center;
	padding: 0 16px;
	margin-bottom: 6px;
	line-height: 26px;
}

.summary-meta {
	font-size: 16px;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.8);
	margin-bottom: 10px;
}

.summary-meta-sep {
	margin: 0 4px;
	color: rgba(255, 255, 255, 0.4);
}

.summary-people {
	font-size: 15px;
	font-weight: 600;
	color: rgba(255, 255, 255, 0.9);
	text-align: center;
	padding: 0 16px;
	line-height: 20px;
}

.summary-publisher {
	font-size: 13px;
	font-weight: 400;
	color: rgba(255, 255, 255, 0.5);
	text-align: center;
	padding: 0 16px;
	margin-top: 2px;
}

</style>
